import { LinearProgress, linearProgressClasses } from '@mui/material';
import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledPackageV3 = styled('div')`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  flex-direction: column;
  .used-credits {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    .label {
      font-size: 14px;
      font-weight: 400;
    }
    .content-wrapper {
      display: flex;
      align-items: center;
      gap: 4px;
      .icon-lock-cycle {
        width: 24px;
        color: ${COLOR.red};
        margin-right: 5px;
      }
      .content {
        font-size: 16px;
        font-weight: 700;
      }
      .tooltip {
        display: flex;
        align-items: center;
        .icon {
          height: 16px;
          width: 16px;
          color: ${COLOR.loadingLoadRequest};
        }
      }
    }
  }
  .next-reset-cycle {
    font-size: 12px;
    font-weight: 400;
    color: ${COLOR.label2[64]};
  }
  .credits-usage-rule {
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: ${COLOR.bluev2[8]};
    padding: 8px;

    .description {
      font-size: 14px;
      font-weight: 400;
    }
  }

  .lock-cycle-notification {
    border-radius: 8px;
    padding: 8px;
    gap: 4px;
    background-color: #ff3b3014;
    display: flex;
    align-items: center;
    .list-note {
      font-size: 10px;
      font-weight: 400;
      color: #ff3b30;
      letter-spacing: -0.4px;
      line-height: 16px;
      ul {
        padding: 0 0 0 16px !important;
        font-size: 10px !important;
        margin: 0;
      }
    }
    .icon-lock-cycle {
      color: #ff3b30;
      font-size: 16px;
    }
  }
`;

export const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: COLOR.activeMenu,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: COLOR.darkBlue,
  },
}));
